import './ProductSummary.css';

import { Attribute } from 'zakeke-configurator-react';

import { generateProductCode } from '../../utils/configuratorLogic';
import { formatData } from '../../utils/mapper';
import { t } from '../../utils/translate';
import { useConfiguratorContext } from '../ConfiguratorWizard/ConfiguratorContext';
import { Product } from '../ProductCard/ProductCard';

interface ProductSummaryProps {
  attributes: Attribute[];
  product: Product;
  othersInfo: {
    sport: string;
    brand: string;
    handle: string;
    gripSize: string;
    gripType: string;
    pipeSize: string;
  };
}

export default function ProductSummary({
  attributes,
  product,
  othersInfo,
}: ProductSummaryProps) {
  const { lang } = useConfiguratorContext();

  const productCode = generateProductCode(formatData(attributes), othersInfo);

  // Request for quote
  const handleGetQuoteClick = () => {
    const quoteData = formatData(attributes);

    window.parent.postMessage(
      {
        type: 'quote',
        othersInfo: { ...othersInfo, productName: product.name },
        parameters: quoteData,
        generatedCode: productCode,
      },
      '*',
    );
  };

  return (
    <div className="summary-card-container">
      <div className="summary-card">
        <p className="summary-card--title">
          {t(lang, 'summary_card_title_code')}
        </p>
        <p>{productCode}</p>
      </div>
      <div className="summary-card">
        <p className="summary-card--title">{t(lang, 'summary_card_title')}</p>
        <strong>{t(lang, 'summary_card_subtitle_1')}</strong>
        <p>{product.name}</p>
        <strong>{t(lang, 'summary_card_subtitle_2')}</strong>
        {Object.entries(formatData(attributes)).map(
          ([optionId, { name, quantity }]) => (
            <p key={optionId}>
              {optionId} ({name}) - x{quantity}
            </p>
          ),
        )}
        <button className="btn-quotation" onClick={handleGetQuoteClick}>
          {t(lang, 'summary_card_btn')}
        </button>
      </div>
    </div>
  );
}
